export default __webpack_public_path__ + "static/media/dashboard.72e0760a.png";